/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { array, lazy, object, Schema } from '../schema';
import { ScheduledPayment, scheduledPaymentSchema } from './scheduledPayment';

export interface Data8 {
  scheduledPayment: ScheduledPayment[];
}

export const data8Schema: Schema<Data8> = object({
  scheduledPayment: [
    'ScheduledPayment',
    array(lazy(() => scheduledPaymentSchema)),
  ],
});
